import apiClient from './apiClient';

/**
 * 📌 SERVICIO DE EMERGENCIAS CORPORATIVAS
 * Maneja las operaciones de emergencias para usuarios corporativos (id_rol=4)
 * Implementa dual write: guarda en tbl_emergencias + tbl_servicios_corporativos
 */

/**
 * 📋 Crear emergencia corporativa
 * @param {Object} emergenciaData - Datos de la emergencia
 * @returns {Promise<Object>} Respuesta con emergencia y servicio corporativo creados
 */
export const crearEmergenciaCorporativa = async (emergenciaData) => {
  try {
    console.log('🚀 [SERVICE-FRONTEND] ========================================');
    console.log('🚀 [SERVICE-FRONTEND] Enviando solicitud de creación de emergencia corporativa');
    console.log('🚀 [SERVICE-FRONTEND] Datos a enviar:', JSON.stringify(emergenciaData, null, 2));
    console.log('🚀 [SERVICE-FRONTEND] Endpoint: POST /emergencias_corporativas');
    console.log('🚀 [SERVICE-FRONTEND] ========================================');

    const response = await apiClient.post('/emergencias_corporativas', emergenciaData);

    console.log('✅ [SERVICE-FRONTEND] ========================================');
    console.log('✅ [SERVICE-FRONTEND] Respuesta recibida exitosamente del backend');
    console.log('✅ [SERVICE-FRONTEND] Status:', response.status);
    console.log('✅ [SERVICE-FRONTEND] Data:', JSON.stringify(response.data, null, 2));
    console.log('✅ [SERVICE-FRONTEND] ========================================');

    return {
      success: true,
      data: response.data.data,
      message: response.data.mensaje
    };
  } catch (error) {
    console.error('❌ [SERVICE-FRONTEND] ========================================');
    console.error('❌ [SERVICE-FRONTEND] ERROR al crear emergencia corporativa');
    console.error('❌ [SERVICE-FRONTEND] Error:', error.message);
    console.error('❌ [SERVICE-FRONTEND] Response:', error.response?.data);
    console.error('❌ [SERVICE-FRONTEND] ========================================');
    return {
      success: false,
      error: error.response?.data?.mensaje || 'Error al crear la emergencia corporativa'
    };
  }
};

/**
 * 📋 Obtener todas las emergencias del usuario corporativo
 * @returns {Promise<Object>} Lista de emergencias
 */
export const obtenerEmergenciasCorporativasUsuario = async () => {
  try {
    const response = await apiClient.get('/emergencias_corporativas/usuario');
    return {
      success: true,
      data: response.data.emergencias
    };
  } catch (error) {
    console.error('Error al obtener emergencias corporativas:', error);
    return {
      success: false,
      error: error.response?.data?.mensaje || 'Error al obtener emergencias'
    };
  }
};

/**
 * 📋 Obtener emergencia activa del usuario corporativo
 * @returns {Promise<Object>} Emergencia activa o null
 */
export const obtenerEmergenciaActivaCorporativa = async () => {
  try {
    const response = await apiClient.get('/emergencias_corporativas/activa');
    return {
      success: true,
      data: response.data.emergencia_activa
    };
  } catch (error) {
    console.error('Error al obtener emergencia activa:', error);
    return {
      success: false,
      error: error.response?.data?.mensaje || 'Error al obtener emergencia activa'
    };
  }
};

/**
 * 📋 Obtener emergencias corporativas completadas sin encuesta
 * @returns {Promise<Object>} Lista de emergencias completadas sin encuesta
 */
export const obtenerEmergenciasCorporativasCompletadasSinEncuesta = async () => {
  try {
    const response = await apiClient.get('/emergencias_corporativas/completadas-sin-encuesta');
    return {
      success: true,
      data: response.data.data
    };
  } catch (error) {
    console.error('Error al obtener emergencias completadas sin encuesta:', error);
    return {
      success: false,
      error: error.response?.data?.mensaje || 'Error al obtener emergencias completadas sin encuesta'
    };
  }
};

/**
 * 📋 Obtener emergencia corporativa por ID
 * @param {number} id - ID de la emergencia
 * @returns {Promise<Object>} Datos completos de la emergencia
 */
export const obtenerEmergenciaPorId = async (id) => {
  try {
    console.log('🔍 [SERVICE] Obteniendo emergencia corporativa por ID:', id);
    const response = await apiClient.get(`/emergencias/${id}`);
    console.log('📦 [SERVICE] Respuesta completa del backend:', response.data);
    return {
      success: true,
      data: response.data  // El backend devuelve directamente la emergencia, no envuelta en {data: ...}
    };
  } catch (error) {
    console.error('❌ [SERVICE] Error al obtener emergencia por ID:', error);
    return {
      success: false,
      error: error.response?.data?.mensaje || 'Error al obtener detalles de la emergencia'
    };
  }
};

const emergenciasCorporativasService = {
  crearEmergenciaCorporativa,
  obtenerEmergenciasCorporativasUsuario,
  obtenerEmergenciaActivaCorporativa,
  obtenerEmergenciasCorporativasCompletadasSinEncuesta,
  obtenerEmergenciaPorId
};

export default emergenciasCorporativasService;